import axios from 'axios'
import { useState } from 'react'
import { useEffect } from 'react'
import { Button, Collapse, Container, Row } from 'react-bootstrap'

import configs from '../../config'
import Cookies from 'js-cookie'

const UserInfo = ({ open = false, toggleFn = () => {}, lotteries = [] }) => {
  const boughtLottery = lotteries.filter((l) => l?.user?.id !== '')

  const userLottery = boughtLottery.reduce((acc, cur) => {
    if (!acc[cur.user.id]) {
      acc[cur.user.id] = []
    }
    acc[cur.user.id].push(cur)
    return acc
  }, {})

  const onToggle = () => {
    if (boughtLottery.length === 0) return

    toggleFn()
  }

  return (
    <Container fluid>
      <Row className="justify-content-center">
        <Button
          disabled={boughtLottery.length === 0}
          size="small"
          onClick={onToggle}
          aria-controls="collapse-info"
          aria-expanded={open}
        >
          User Info
        </Button>
      </Row>
      <Collapse in={open}>
        <div id="collapse-info">
          {open &&
            Object.keys(userLottery).map((userId) => (
              <Info key={`user-info-${userId}`} userId={userId} lotteries={userLottery[userId]} />
            ))}
        </div>
      </Collapse>
    </Container>
  )
}

const Info = ({ userId = '', lotteries = [] }) => {
  const [user, setUser] = useState(null)

  useEffect(() => {
    if (!userId) return
    ;(async () => {
      try {
        const res = await axios.get(`${configs.apiAdminGateway}/api/v1/admin/users/${userId}`, {
          headers: { Authorization: `Bearer ${Cookies.get('accessToken')}` },
        })

        const {
          status: { code, description },
          data,
        } = res.data

        if (code !== 0) {
          throw new Error(description)
        }

        setUser(data)
      } catch (err) {
        setUser(null)
      }
    })()
  }, [userId])

  return (
    <Container>
      <div>รหัสผู้ใช้งาน : {user ? `${user.userId}` : 'ไม่พบข้อมูล'}</div>
      <div>
        ชื่อ : {user ? `${user.firstName} ${user.lastName}` : 'ไม่พบข้อมูล'} {`(${lotteries.length} ใบ)`}
      </div>
      <div>ชื่อเล่น : {user ? `${user.nickName}` : 'ไม่พบข้อมูล'}</div>
      <div>จังหวัด : {user ? `${user.address?.province}` : 'ไม่พบข้อมูล'}</div>
      <div>เบอร์โทร : {user ? `${user.phone}` : 'ไม่พบข้อมูล'}</div>
      <hr />
    </Container>
  )
}

export default UserInfo
